import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare var $: any;
import { debounceTime } from "rxjs/operators";
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { emailPattern, mobilePattern, noWhitespaceInRequiredValidator, password_validation, task_management_access_modules } from '../../shared/constants';
/* import { SignaturePadComponent } from '@almothafar/angular-signature-pad'; */
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { AccessModulesComponent } from '../../role-master/access-modules/access-modules.component';

@Component({
	selector: 'app-mdm-user-create',
	templateUrl: './mdm-user-create.component.html',
	styleUrl: './mdm-user-create.component.scss'
})
export class MdmUserCreateComponent implements AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		/* {
			path: '/app/dashboard-mdm',
			name: "MDM"
		}, */
		{
			path: "/app/mdm-users",
			name: "MDM Users"
		}
	];
	/* mailSignature = '<p><strong><br></strong></p><p><strong><br></strong></p><p><strong>Please confirm receipt of this email.</strong></p><p><strong><br></strong></p><p><strong>In case of emergency, please feel free to contact us via the telephone or the email link.</strong></p><p><strong><br></strong></p><p><strong>DO NOT SELF DIAGNOSE AND TREAT. OUR DOC TEAM IS AT YOUR SERVICE 24x7</strong></p><p><strong><br></strong></p><p><strong>Stay fit, Stay healthy!</strong></p><p><strong>Thanks &amp; Regards,</strong></p><p><strong><br></strong></p><p><strong>DOC Team</strong></p><p><strong>3Cube Medicare</strong></p><p><strong>PHONE -&nbsp;</strong><span style=\"background-color: unset; text-align: inherit;\"><strong>+91 80-6912-3333</strong></span></p><p><strong>PHONE -&nbsp;</strong><span style=\"background-color: unset; text-align: inherit;\"><strong>+852 8199-9121</strong></span></p><p><strong>Email Id  - rma@dutyofcare365.com</strong></p><p><strong>Platform:&nbsp;</strong><span style=\"background-color: unset; text-align: inherit;\"><a class=\"e-rte-anchor\" href=\"http://doc.3cubemedicare.com\" title=\"http://doc.3cubemedicare.com\" target=\"_blank\">doc.3cubemedicare.com</a></span></p><p><strong>Web:</strong>&nbsp;<a class=\"e-rte-anchor\" href=\"http://www.3cubemedicare.com\" title=\"http://www.3cubemedicare.com\" target=\"_blank\">www.3cubemedicare.com</a></p><p><span><strong>FB Link:&nbsp;</strong></span><a classname=\"e-rte-anchor\" href=\"www.facebook.com/3cubeservices\" title=\"www.facebook.com/3cubeservices\" style=\"text-align: inherit;\">www.facebook.com/3cubeservices</a></p><p>The contents of this email are confidential and handled in accordance to set compliance standards. This email is intended for the addressee only. Access to this message by any person other than the intended recipient(s) is unauthorised, and any disclosure or copying of or reliance upon the information contained in this message or any attachments is prohibited. If you have received this message in error, you must preserve its confidentiality, notify the sender immediately and delete the material from your computer.</p><p><br></p><p>Please note to maintain confidentiality we do not add other than authorised persons on the communication.</p><p><a classname=\"e-rte-anchor\" href=\"www.dutyofcare365.com\" title=\"www.dutyofcare365.com\"><strong> </strong></a></p>'; */
	uId: any = null;
	pagetitle = "Create MDM User";
	moduleForm: FormGroup = this.formBuilder.group({
		first_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		last_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		email: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
		gender: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		country_code: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		contact_no: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
		registration_no: [null],
		qualification: [null],
		mdm_role: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		is_specialist: [0],
		dg_no: [null],
		licence_auth: [null],
		licence_date: [null],
		/* signature: [null],
		email_signature: [this.mailSignature], */
		enable2fa: [false],
		emp_code: [null],
		department: [null],
		password: [null, [Validators.required, noWhitespaceInRequiredValidator, password_validation]],
		confirm_password: [null, [Validators.required, noWhitespaceInRequiredValidator]],
	}, {
		validators: this.passwordMatchValidator.bind(this)
	});
	showLoader: boolean = false;
	showDeleteLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	hideP = true;
	formSubmitted = false;
	countries: any = [];
	roles: any = [];
	departments: any = [];
	/* @ViewChild(SignaturePadComponent) signaturePad!: SignaturePadComponent;
	signaturePadOptions: any = {
		'minWidth': 5,
		'canvasWidth': 300,
		'canvasHeight': 200
	};
	digitalSignaturePreview: any = null;
	signaturePath: any = null;
	errorLog: any = null;
	errorLogs = false;
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline', 'strike'],
				['blockquote', 'code-block'],
				[{ 'header': 1 }, { 'header': 2 }],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'script': 'sub' }, { 'script': 'super' }],
				[{ 'indent': '-1' }, { 'indent': '+1' }],
				[{ 'direction': 'rtl' }],
				[{ 'size': ['small', false, 'large', 'huge'] }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }],
				['clean'],
				['link']
			],
		}
	}
	File_Storage_URL = environment.File_Storage_URL; */
	user_type: any = "";
	accessLoader = false;
	isDoctor = true;
	@ViewChild('accessModuleRef') accessForm!: AccessModulesComponent;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe((data: any) => {
			this.accessLoader = false;
			try {
				this.user_type = data.res[0].user_type;
				let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
				this.UserModuleAccess = accessObj["USER_Module"];
			} catch (error) { }
		}, (error: any) => {
			this.accessLoader = false;
			this.UserModuleAccess = "NoAccess";
		});
	}

	ngAfterViewInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.getCountryCodes();
			this.getRoles();
			this.getDepartment();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/mdm-edit-user/" + this.uId, name: "Edit MDM User" });
				this.pagetitle = "Edit User";
				this.pageLoading = true;
				this.getDetails();
				this.f.password.clearValidators();
				this.f.password.setValidators(null);
				this.f.password.updateValueAndValidity();
				this.f.confirm_password.clearValidators();
				this.f.confirm_password.setValidators(null);
				this.f.confirm_password.updateValueAndValidity();
				this.f.email.disable();
			} else {
				this.breadcrumbList.push({ path: "/app/mdm-create-user", name: "Add MDM User" });
				this.pageLoading = true;
			}
		});
	}

	/* drawComplete() {
		this.f.signature.setValue(this.dataURLtoFile(this.signaturePad.toDataURL("png"), "signature.png"));
		this.digitalSignaturePreview = null;
		this.formChanged();
	}

	dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[arr.length - 1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	}

	drawStart() { }

	clearSign() {
		this.signaturePad.clear();
	}

	public caseFilesUpload(files: NgxFileDropEntry[]) {
		const droppedFile = files[0];
		if (droppedFile.fileEntry.isFile) {
			const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
			fileEntry.file((file: File) => {
				this.f.signature.setValue(file);
				this.formChanged();
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
					this.digitalSignaturePreview = reader.result;
					this.signaturePad.clear();
				};
			});
		} else {
			this.errorLog = "Invalid File Format.";
			this.errorLogs = true;
			setTimeout(() => {
				this.errorLogs = false;
			}, 10000);
			this.toastr.error("Invalid File Format.", 'Error', {
				disableTimeOut: true,
				tapToDismiss: true,
				closeButton: true
			});
		}
	} */

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	genderChanged(e: any) {
		this.f.gender.setValue(e.value);
	}

	getDetails() {
		this.apiService.getMDMUserDetails({ "id": this.uId }).subscribe((data: any) => {
			this.details = data.data;
			this.f.first_name.setValue(this.details.first_name);
			this.f.last_name.setValue(this.details.last_name);
			this.f.email.setValue(this.details.email);
			this.f.gender.setValue(this.details.gender);
			this.f.country_code.setValue(this.details.country_code);
			this.f.contact_no.setValue(this.details.contact_no);
			this.f.registration_no.setValue(this.details.registration_no);
			this.f.qualification.setValue(this.details.qualification);
			this.f.is_specialist.setValue(this.details.is_specialist);
			this.f.mdm_role.setValue(this.details.mdm_role);
			this.f.dg_no.setValue(this.details.dg_no);
			this.f.licence_auth.setValue(this.details.licence_auth);
			this.f.licence_date.setValue(this.apiService.getDateFromDateString(this.details.licence_date));
			this.f.enable2fa.setValue(this.details.enable2fa);
			this.f.emp_code.setValue(this.details.emp_code);
			this.f.department.setValue(this.details.department);
			/* this.f.email_signature.setValue(this.details.email_signature);
			this.signaturePath = this.File_Storage_URL + this.details.signature; */
			this.roleChanged(false);
			this.accessForm.setAccess(this.details.tms_access);
		}, (error) => {
			this.pageLoading = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to fetch details.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe((data: any) => {
			data.map((c: any) => {
				c.display = c.dial_code + "(" + c.name + ")"
				return c;
			})
			this.countries = data;
		}, (error) => {
			this.countries = [];
		});
	}

	roleChanged(changedByUser: boolean) {
		this.isDoctor = true;
		if (this.f.mdm_role.value) {
			for (let k = 0; k < this.roles.length; k++) {
				if (this.roles[k].id == this.f.mdm_role.value) {
					if (this.roles[k].name == "admin") {
						this.isDoctor = false;
					}
					if (changedByUser) {
						this.accessForm.setAccess(this.roles[k].access);
					}
				}
			}
		}
	}

	getRoles() {
		this.apiService.getRoles().subscribe({
			next: (data: any) => {
				this.roles = data;
				this.roleChanged(false);
			}, error: (error) => {
				this.roles = [];
			}
		});
	}

	getDepartment() {
		this.apiService.getDepartments().subscribe({
			next: (data: any) => {
				this.departments = data;
				this.roleChanged(false);
			}, error: (error) => {
				this.departments = [];
			}
		});
	}

	passwordMatchValidator(formGroup: FormGroup) {
		if (this.uId) {
			return null;
		}
		const password = formGroup.get('password');
		const confirm_password = formGroup.get('confirm_password');
		return password!.value === confirm_password!.value ? null : { passwordNotMatch: true };
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload = new FormData();
		payload.append("email", this.f.email.value ? this.f.email.value : "");
		payload.append("gender", this.f.gender.value ? this.f.gender.value : "");
		payload.append("country_code", this.f.country_code.value ? this.f.country_code.value : "");
		payload.append("contact_no", this.f.contact_no.value ? this.f.contact_no.value : "");
		payload.append("registration_no", this.f.registration_no.value ? this.f.registration_no.value : "");
		payload.append("qualification", this.f.qualification.value ? this.f.qualification.value : "");
		payload.append("is_specialist", this.f.is_specialist.value);
		payload.append("dg_no", this.f.dg_no.value ? this.f.dg_no.value : "");
		payload.append("licence_auth", this.f.licence_auth.value ? this.f.licence_auth.value : "");
		payload.append("licence_date", this.apiService.getDateStringFromDate(this.f.licence_date.value));
		payload.append("last_name", this.f.last_name.value ? this.f.last_name.value : "");
		payload.append("first_name", this.f.first_name.value ? this.f.first_name.value : "");
		payload.append("emp_code", this.f.emp_code.value ? this.f.emp_code.value : "");
		payload.append("department", this.f.department.value ? this.f.department.value : "");
		payload.append("mdm_role", this.f.mdm_role.value ? this.f.mdm_role.value : "");
		/* payload.append("signature", this.f.signature.value?this.f.signature.value:"");
		payload.append("email_signature", this.f.email_signature.value?this.f.email_signature.value:""); */
		payload.append("signature", "");
		payload.append("email_signature", "");
		payload.append("enable2fa", this.f.enable2fa.value ? "True" : "False");
		if (this.uId) {
			payload.append("id", this.uId);
		} else {
			payload.append("password", this.f.password.value);
		}
		payload.append("tms_access", JSON.stringify(this.accessForm.getAccessObj()));
		/* let payload: any = {
			email: this.f.email.value,
			gender: this.f.gender.value,
			country_code: this.f.country_code.value,
			contact_no: this.f.contact_no.value,
			registration_no: this.f.registration_no.value,
			qualification: this.f.qualification.value,
			is_specialist: this.f.is_specialist.value,
			dg_no: this.f.dg_no.value,
			licence_auth: this.f.licence_auth.value,
			email_signature: this.f.email_signature.value,
			licence_date: this.apiService.getDateStringFromDate(this.f.licence_date.value),
			last_name: this.f.last_name.value,
			first_name: this.f.first_name.value,
			emp_code: this.f.emp_code.value,
			department: this.f.department.value,
			mdm_role: this.f.mdm_role.value,
			signature: this.f.signature.value
		}
		if (this.uId) {
			payload["id"] = this.uId;
		}else{
			payload["password"] = this.f.password.value;
		} */
		this.showLoader = true;
		this.apiService.createUpdateMDMUser(payload).subscribe(data => {
			this.showLoader = false;
			this.toastr.success("Saved successfully.", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.gotoList();
		}, (error: any) => {
			this.showLoader = false;
			if (error.status == 401) { return }
			if (error.status == 409) {
				Swal.fire({
					title: 'Already Exists',
					html: 'User with email <strong>' + this.f.email.value + '</strong> already exists. Do you want to restore it?',
					icon: 'question',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: 'Yes, Restore!',
					cancelButtonText: 'Cancel',
					confirmButtonColor: '#3e4fb1'
				}).then((result) => {
					if (result.value) {
						this.apiService.restoreMDMUser(error.error).subscribe((data: any) => {
							this.toastr.success("User restored successfully", 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.gotoList();
						}, (error) => {
							this.toastr.error("Something went wrong", 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						});
					} else if (result.dismiss === Swal.DismissReason.cancel) { }
				})
			} else {
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}

						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	gotoList() {
		this.router.navigate(['/app/mdm-users']);
	}
}
